@import './pk-tab-panel.variables';

:host {
  @apply hidden px-[--tab-panel--padding-x] py-[--tab-panel--padding-y];
}

:host(.active) {
  @apply block;
}
